module.exports = __webpack_public_path__ + "img/home-hero-16by9.7d409237.svg";